export default {
  RESUME: {
    basic: {
      fontType: 'Tinos Times New Roman',
      nameSize: 24,
      taglineSize: 14,
      headingSize: 12,
      subHeadingSize: 12,
      contentSize: 12,
      sectionSpacing: 8,
      paragraphSpacing: 4,
      lineSpacing: 1.15,
      topMargin: 16,
      bottomMargin: 16,
      leftMargin: 16,
      rightMargin: 16,
    },
    gradient: {
      fontType: 'Tinos Times New Roman',
      nameSize: 24,
      taglineSize: 14,
      headingSize: 12,
      subHeadingSize: 12,
      contentSize: 12,
      sectionSpacing: 8,
      paragraphSpacing: 4,
      lineSpacing: 1.15,
      topMargin: 16,
      bottomMargin: 16,
      leftMargin: 16,
      rightMargin: 16,
    },
    streak: {
      fontType: 'Arial',
      nameSize: 24,
      taglineSize: 14,
      headingSize: 12,
      subHeadingSize: 12,
      contentSize: 12,
      sectionSpacing: 8,
      paragraphSpacing: 4,
      lineSpacing: 1.15,
      topMargin: 16,
      bottomMargin: 16,
      leftMargin: 16,
      rightMargin: 16,
    },
    proxima: {
      fontType: 'Arial',
      nameSize: 24,
      taglineSize: 14,
      headingSize: 12,
      subHeadingSize: 12,
      contentSize: 12,
      sectionSpacing: 8,
      paragraphSpacing: 4,
      lineSpacing: 1.15,
      topMargin: 16,
      bottomMargin: 16,
      leftMargin: 16,
      rightMargin: 16,
    },
    falcon: {
      fontType: 'Arial',
      nameSize: 24,
      taglineSize: 14,
      headingSize: 12,
      subHeadingSize: 12,
      contentSize: 12,
      sectionSpacing: 8,
      paragraphSpacing: 4,
      lineSpacing: 1.15,
      topMargin: 16,
      bottomMargin: 16,
      leftMargin: 16,
      rightMargin: 16,
    },
    techie: {
      fontType: 'Arial',
      nameSize: 24,
      taglineSize: 14,
      headingSize: 12,
      subHeadingSize: 12,
      contentSize: 12,
      sectionSpacing: 8,
      paragraphSpacing: 4,
      lineSpacing: 1.15,
      topMargin: 16,
      bottomMargin: 16,
      leftMargin: 16,
      rightMargin: 16,
    },
    orion: {
      fontType: 'Arial',
      nameSize: 24,
      taglineSize: 14,
      headingSize: 12,
      subHeadingSize: 12,
      contentSize: 12,
      sectionSpacing: 8,
      paragraphSpacing: 4,
      lineSpacing: 1.15,
      topMargin: 16,
      bottomMargin: 16,
      leftMargin: 16,
      rightMargin: 16,
    },
    simple: {
      fontType: 'Tinos Times New Roman',
      nameSize: 24,
      taglineSize: 14,
      headingSize: 12,
      subHeadingSize: 12,
      contentSize: 12,
      sectionSpacing: 8,
      paragraphSpacing: 4,
      lineSpacing: 1.15,
      topMargin: 16,
      bottomMargin: 16,
      leftMargin: 16,
      rightMargin: 16,
    },
    stellar: {
      fontType: 'Arial',
      nameSize: 24,
      taglineSize: 14,
      headingSize: 12,
      subHeadingSize: 12,
      contentSize: 12,
      sectionSpacing: 8,
      paragraphSpacing: 4,
      lineSpacing: 1.15,
      topMargin: 16,
      bottomMargin: 16,
      leftMargin: 16,
      rightMargin: 16,
    },
    businessmajor: {
      fontType: 'Arial',
      nameSize: 24,
      taglineSize: 14,
      headingSize: 12,
      subHeadingSize: 12,
      contentSize: 12,
      sectionSpacing: 8,
      paragraphSpacing: 4,
      lineSpacing: 1.15,
      topMargin: 16,
      bottomMargin: 16,
      leftMargin: 16,
      rightMargin: 16,
    },
    functional: {
      fontType: 'Arial',
      nameSize: 24,
      taglineSize: 14,
      headingSize: 12,
      subHeadingSize: 12,
      contentSize: 12,
      sectionSpacing: 8,
      paragraphSpacing: 4,
      lineSpacing: 1.15,
      topMargin: 16,
      bottomMargin: 16,
      leftMargin: 16,
      rightMargin: 16,
    },
    agricultural: {
      fontType: 'Arial',
      nameSize: 24,
      taglineSize: 14,
      headingSize: 12,
      subHeadingSize: 12,
      contentSize: 12,
      sectionSpacing: 8,
      paragraphSpacing: 4,
      lineSpacing: 1.15,
      topMargin: 16,
      bottomMargin: 16,
      leftMargin: 16,
      rightMargin: 16,
    },
    geospatial: {
      fontType: 'Arial',
      nameSize: 24,
      taglineSize: 14,
      headingSize: 12,
      subHeadingSize: 12,
      contentSize: 12,
      sectionSpacing: 8,
      paragraphSpacing: 4,
      lineSpacing: 1.15,
      topMargin: 16,
      bottomMargin: 16,
      leftMargin: 16,
      rightMargin: 16,
    },
    emblem: {
      fontType: 'Tinos Times New Roman',
      nameSize: 24,
      taglineSize: 14,
      headingSize: 12,
      subHeadingSize: 12,
      contentSize: 12,
      sectionSpacing: 8,
      paragraphSpacing: 4,
      lineSpacing: 1.15,
      topMargin: 16,
      bottomMargin: 16,
      leftMargin: 16,
      rightMargin: 16,
    },
    attractive: {
      fontType: 'Manrope',
      nameSize: 24,
      taglineSize: 14,
      headingSize: 12,
      subHeadingSize: 12,
      contentSize: 12,
      sectionSpacing: 8,
      paragraphSpacing: 4,
      lineSpacing: 1.15,
      topMargin: 16,
      bottomMargin: 16,
      leftMargin: 16,
      rightMargin: 16,
    },
    vintage: {
      fontType: 'Tinos Times New Roman',
      nameSize: 24,
      taglineSize: 14,
      headingSize: 12,
      subHeadingSize: 12,
      contentSize: 12,
      sectionSpacing: 8,
      paragraphSpacing: 4,
      lineSpacing: 1.15,
      topMargin: 16,
      bottomMargin: 16,
      leftMargin: 16,
      rightMargin: 16,
    },
    nineties: {
      fontType: 'Tinos Times New Roman',
      nameSize: 24,
      taglineSize: 14,
      headingSize: 12,
      subHeadingSize: 12,
      contentSize: 12,
      sectionSpacing: 8,
      paragraphSpacing: 4,
      lineSpacing: 1.15,
      topMargin: 16,
      bottomMargin: 16,
      leftMargin: 16,
      rightMargin: 16,
    },
    elegant: {
      fontType: 'Manrope',
      nameSize: 24,
      taglineSize: 14,
      headingSize: 12,
      subHeadingSize: 12,
      contentSize: 12,
      sectionSpacing: 8,
      paragraphSpacing: 4,
      lineSpacing: 1.15,
      topMargin: 16,
      bottomMargin: 16,
      leftMargin: 16,
      rightMargin: 16,
    },
    exemplary: {
      fontType: 'Tinos Times New Roman',
      nameSize: 24,
      taglineSize: 14,
      headingSize: 12,
      subHeadingSize: 12,
      contentSize: 12,
      sectionSpacing: 8,
      paragraphSpacing: 4,
      lineSpacing: 1.15,
      topMargin: 16,
      bottomMargin: 16,
      leftMargin: 16,
      rightMargin: 16,
    },
    inventor: {
      fontType: 'Tinos Times New Roman',
      nameSize: 24,
      taglineSize: 14,
      headingSize: 12,
      subHeadingSize: 12,
      contentSize: 12,
      sectionSpacing: 8,
      paragraphSpacing: 4,
      lineSpacing: 1.15,
      topMargin: 16,
      bottomMargin: 16,
      leftMargin: 16,
      rightMargin: 16,
    },
    classic: {
      fontType: 'Arial',
      nameSize: 24,
      taglineSize: 14,
      headingSize: 12,
      subHeadingSize: 12,
      contentSize: 12,
      sectionSpacing: 8,
      paragraphSpacing: 4,
      lineSpacing: 1.15,
      topMargin: 16,
      bottomMargin: 16,
      leftMargin: 16,
      rightMargin: 16,
    },
  },

  COVER_LETTER: {
    basic: {
      fontType: 'Manrope',
      nameSize: 24,
      taglineSize: 14,
      headingSize: 18,
      subHeadingSize: 12,
      contentSize: 12,
      sectionSpacing: 12,
      paragraphSpacing: 8,
      lineSpacing: 1.5,
      topMargin: 16,
      bottomMargin: 16,
      leftMargin: 16,
      rightMargin: 16,
    },
    gradient: {
      fontType: 'Manrope',
      nameSize: 24,
      taglineSize: 14,
      headingSize: 18,
      subHeadingSize: 12,
      contentSize: 12,
      sectionSpacing: 12,
      paragraphSpacing: 8,
      lineSpacing: 1.5,
      topMargin: 16,
      bottomMargin: 16,
      leftMargin: 16,
      rightMargin: 16,
    },
    simple: {
      fontType: 'Manrope',
      nameSize: 24,
      taglineSize: 14,
      headingSize: 18,
      subHeadingSize: 12,
      contentSize: 12,
      sectionSpacing: 12,
      paragraphSpacing: 8,
      lineSpacing: 1.5,
      topMargin: 16,
      bottomMargin: 16,
      leftMargin: 16,
      rightMargin: 16,
    },
    emblem: {
      fontType: 'Manrope',
      nameSize: 24,
      taglineSize: 14,
      headingSize: 18,
      subHeadingSize: 12,
      contentSize: 12,
      sectionSpacing: 12,
      paragraphSpacing: 8,
      lineSpacing: 1.5,
      topMargin: 16,
      bottomMargin: 16,
      leftMargin: 16,
      rightMargin: 16,
    },
    attractive: {
      fontType: 'Manrope',
      nameSize: 24,
      taglineSize: 14,
      headingSize: 18,
      subHeadingSize: 12,
      contentSize: 12,
      sectionSpacing: 20,
      paragraphSpacing: 8,
      lineSpacing: 1.5,
      topMargin: 16,
      bottomMargin: 16,
      leftMargin: 16,
      rightMargin: 16,
    },
    vintage: {
      fontType: 'Manrope',
      nameSize: 24,
      taglineSize: 14,
      headingSize: 18,
      subHeadingSize: 12,
      contentSize: 12,
      sectionSpacing: 12,
      paragraphSpacing: 8,
      lineSpacing: 1.5,
      topMargin: 16,
      bottomMargin: 16,
      leftMargin: 16,
      rightMargin: 16,
    },
    nineties: {
      fontType: 'Manrope',
      nameSize: 24,
      taglineSize: 14,
      headingSize: 18,
      subHeadingSize: 12,
      contentSize: 12,
      sectionSpacing: 12,
      paragraphSpacing: 8,
      lineSpacing: 1.5,
      topMargin: 16,
      bottomMargin: 16,
      leftMargin: 16,
      rightMargin: 16,
    },
    inventor: {
      fontType: 'Manrope',
      nameSize: 24,
      taglineSize: 14,
      headingSize: 18,
      subHeadingSize: 12,
      contentSize: 12,
      sectionSpacing: 12,
      paragraphSpacing: 8,
      lineSpacing: 1.5,
      topMargin: 16,
      bottomMargin: 16,
      leftMargin: 16,
      rightMargin: 16,
    },
    elegant: {
      fontType: 'Tinos Times New Roman',
      nameSize: 24,
      taglineSize: 14,
      headingSize: 18,
      subHeadingSize: 12,
      contentSize: 12,
      sectionSpacing: 12,
      paragraphSpacing: 8,
      lineSpacing: 1.5,
      topMargin: 16,
      bottomMargin: 16,
      leftMargin: 16,
      rightMargin: 16,
    },
    exemplary: {
      fontType: 'Manrope',
      nameSize: 24,
      taglineSize: 14,
      headingSize: 18,
      subHeadingSize: 12,
      contentSize: 12,
      sectionSpacing: 12,
      paragraphSpacing: 8,
      lineSpacing: 1.5,
      topMargin: 16,
      bottomMargin: 16,
      leftMargin: 16,
      rightMargin: 16,
    },
  },
};
